(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .controller('AdjustBenDialogEditController', AdjustBenDialogEditController);

    AdjustBenDialogEditController.$inject = ['$scope', '$uibModalInstance', 'items','index','CommonService'];

    function AdjustBenDialogEditController ($scope, $uibModalInstance, item,index,CommonService) {
    	var adjustBenDialEdit = this;
    	if(item.customer.wardCode==null||item.customer.wardCode==undefined){
    		item.customer.wardCode=item.customer.locationCode;
    	}
    	adjustBenDialEdit.customer={
    			idNum:item.customer.idNum,
    			lastName:item.customer.lastName,
    			firstName:item.customer.firstName,
    			salutation:item.customer.salutation,
    			gender:item.customer.gender,
    			married:item.customer.married,
    			occupationCode:item.customer.occupationCode,
    			birthPlace:item.customer.birthPlace,
    			nationality:item.customer.nationality,
    			address:item.customer.address,
    			birthDate:new Date(item.customer.birthDate),
    			idNumDate:new Date(item.customer.idNumDate),
    			provinceCode:item.customer.wardCode.substr(0, 2),
				districtCode:item.customer.wardCode.substr(0, 4),
				wardCode:item.customer.wardCode,
				locationCode:item.customer.wardCode,
				mobileCode:item.customer.mobileCode,
				mobilePhone:item.customer.mobilePhone,
				valueSms:item.customer.valueSms,
				email:item.customer.email,
				valueEmail:item.customer.valueEmail,
    	}
    	adjustBenDialEdit.validateGender=false;
    	adjustBenDialEdit.adjustBenId=item.adjustBenId;
    	adjustBenDialEdit.benCode=item.benName;
    	adjustBenDialEdit.benRatio=item.benRatio;
    	adjustBenDialEdit.benRelation=item.benRelation;
    	adjustBenDialEdit.index=index;
//    	if(item.customer.locationCode!=undefined){
//    		adjustBenDialEdit.customer.provinceCode=item.customer.locationCode.substr(0, 2);
//    		adjustBenDialEdit.customer.districtCode=item.customer.locationCode.substr(0, 4);
//    		adjustBenDialEdit.customer.wardCode=item.customer.locationCode;
//    	}
    	adjustBenDialEdit.ok= ok;
    	adjustBenDialEdit.cancel= cancel;
    	adjustBenDialEdit.genderTypes=genderTypes;
		adjustBenDialEdit.marriedTypes=marriedTypes;
		adjustBenDialEdit.agreeEmailTypes=agreeEmailTypes;
		adjustBenDialEdit.agreeSmsTypes=agreeSmsTypes;
		adjustBenDialEdit.salutlTypes=salutlTypes;
		adjustBenDialEdit.lstNationality = CommonService.query({masterurl:'nationality'});
    	adjustBenDialEdit.lstProvince = CommonService.query({masterurl:'province'});
    	adjustBenDialEdit.lstDistrict = CommonService.query({masterurl:'district',provinceCode:adjustBenDialEdit.customer.provinceCode});
    	adjustBenDialEdit.lstWard = CommonService.query({masterurl:'ward',districtCode:adjustBenDialEdit.customer.districtCode});
    	adjustBenDialEdit.lstOcupation =CommonService.query({masterurl:'occupation'});
    	adjustBenDialEdit.lstPhoneCode=CommonService.query({masterurl:'phone-code'});
    	adjustBenDialEdit.getAllDistrictByProvince = function(cityCode){
    		if (cityCode != null || cityCode != undefined && (num != null || num != undefined)){
    			adjustBenDialEdit.lstDistrict = CommonService.query({masterurl:'district',provinceCode:cityCode});
    		}else{
    			adjustBenDialEdit.lstDistrict = null;
    		}
    	}
    	// Get Wards
    	adjustBenDialEdit.getAllWardByDistrict = function(districtCode){
    		if (districtCode != null || districtCode != undefined && (districtCode != null || districtCode != undefined)){
    			adjustBenDialEdit.lstWard = CommonService.query({masterurl:'ward',districtCode:districtCode});
    		}else{
    			adjustBenDialEdit.lstWard = null;
    		}
    	}
    	adjustBenDialEdit.changeGender=function(){
    		if(adjustBenDialEdit.customer.salutation==salutlTypes[0].codeSalutl){
    			if(adjustBenDialEdit.customer.gender=='M'){
    				adjustBenDialEdit.validateGender=false;
    			}else{
    				adjustBenDialEdit.validateGender=true;
    			}
    		}else if(adjustBenDialEdit.customer.salutation==salutlTypes[1].codeSalutl||adjustBenDialEdit.customer.salutation==salutlTypes[3].codeSalutl){
    			if(adjustBenDialEdit.customer.gender=='F'){
    				adjustBenDialEdit.validateGender=false;
    			}else{
    				adjustBenDialEdit.validateGender=true;
    			}
    		}else{
    			adjustBenDialEdit.validateGender=false;
    		}
    	}
//    	adjustBenDialEdit.selected = {
//    	    item: adjustBenDialEdit
//    	  };

    	  function ok() {
    	   adjustBenDialEdit.customer.locationCode=adjustBenDialEdit.customer.wardCode;
    	   adjustBenDialEdit.selected = {
      	    item: adjustBenDialEdit
    	   };
    	    $uibModalInstance.close(adjustBenDialEdit.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    	  adjustBenDialEdit.dob = new Date();
  		adjustBenDialEdit.openDob = function() {
  			adjustBenDialEdit.popupDob.opened = true;
  		};
  		adjustBenDialEdit.didNum = new Date();
  		adjustBenDialEdit.openDidNum = function() {
  			adjustBenDialEdit.popupDidNum.opened = true;
  		};

  		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
  				'shortDate' ];
  		$scope.format = $scope.formats[2];
  		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
  		adjustBenDialEdit.popupDob = {
  			opened : false
  		};
  		adjustBenDialEdit.popupDidNum = {
  				opened : false
  			};
    }
})();
